import {
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { findSalesAgents } from "../services/sales";
import { selectLoggedInUser } from "./auth";
import { addToSuggestions, SalesAgentSuggestion } from "../suggestions";

const salesAgentsAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

const initialState = salesAgentsAdapter.getInitialState();

const salesAgentsSlice = createSlice({
  name: "salesAgents",
  initialState,
  reducers: {
    setSalesAgents: salesAgentsAdapter.setAll,
  },
});

export default salesAgentsSlice.reducer;

export const { setSalesAgents } = salesAgentsSlice.actions;

export const selectors = salesAgentsAdapter.getSelectors(
  (state) => state.salesAgents,
);

export const selectCurrentSalesAgent = createSelector(
  (state) => state,
  selectLoggedInUser,
  (state, currentUser) =>
    selectors.selectById(state, currentUser?.meta?.sa?.id),
);

export const loadSalesAgents = createAsyncThunk(
  "salesAgents/loadAll",
  (_, { dispatch }) =>
    findSalesAgents().then((salesAgents) => {
      addToSuggestions(salesAgents.map(SalesAgentSuggestion));
      dispatch(setSalesAgents(salesAgents));
    }),
);
